import React from 'react';
import SectionTitle from '../components/SectionTitle';
import Team from '../components/Team';
import { StyledTeamArea } from './styles/StyledTeamArea';

const sectionProps = {
  textAlign: 'text-center',
  radiusRounded: '',
  title: (
    <h2 className="heading-1">
      <span className="meet">MEET</span>The Team
    </h2>
  ),
  subtitle: 'Personal Consultants Dedicated to You.',
  description:'Our distinguished medical staff bring with them impressive qualifications and decades of research and industry experience.',
};

const MeetTheTeam = ({ bgColor, id, content }) => {
  return (
    <StyledTeamArea
      className="rn-section-gap"
      style={{ backgroundColor: bgColor, position: 'relative' }}
    >
      <div id='meet-the-team' style={{ position: 'absolute' }}></div>
      <div id={id} className="container">
        <div className="row">
          <div className="col-lg-12">
            <SectionTitle {...sectionProps} />
          </div>
        </div>
        <Team content={content} column="col-lg-4 col-md-6 col-12" />
        <div>
          <h4 className="heading-5">Our Clinical Partner</h4>
          <p className="text-block-2 partner">
            We partner with{' '}
            <a href="https://nexgenprecision.com/" target="_blank" className="text-button">
              Nexgen Precision{' '}
            </a>
            to ensure all of our processes are optimized for both providers and patients, and to
            achieve the highest standards of clinical excellence.
          </p>
        </div>
      </div>
    </StyledTeamArea>
  );
};

export default MeetTheTeam;
